(() => {
  const isFlyingtimeProduct = (root) => {
    const productInfo = root.closest?.('product-info') || root.querySelector?.('product-info');
    const variantSelects = productInfo?.querySelector('variant-selects');
    if (!variantSelects) return false;

    const legends = Array.from(variantSelects.querySelectorAll('.form__label'))
      .map((legend) => legend.textContent.trim().toLowerCase());

    return legends.includes('format') && legends.includes('size');
  };

  const forceAvailable = (root = document) => {
    const scopes = root.matches?.('product-info') ? [root] : Array.from(root.querySelectorAll?.('product-info') || []);

    scopes.forEach((scope) => {
      if (!isFlyingtimeProduct(scope)) return;

      scope.querySelectorAll('.price--sold-out').forEach((price) => price.classList.remove('price--sold-out'));
      scope.querySelectorAll('.price__badge-sold-out').forEach((badge) => {
        badge.hidden = true;
        badge.setAttribute('aria-hidden', 'true');
      });

      scope.querySelectorAll('variant-selects input.disabled').forEach((input) => input.classList.remove('disabled'));
      scope.querySelectorAll('variant-selects .label-unavailable').forEach((label) => {
        label.hidden = true;
        label.setAttribute('aria-hidden', 'true');
      });

      scope.querySelectorAll('product-form').forEach((productForm) => {
        const variantInput = productForm.querySelector('[name="id"]');
        const submitButton = productForm.querySelector('[type="submit"]');
        const submitText = submitButton?.querySelector('span');

        variantInput?.removeAttribute('disabled');
        submitButton?.removeAttribute('disabled');
        submitButton?.removeAttribute('aria-disabled');
        if (submitText && window.variantStrings?.addToCart) {
          submitText.textContent = window.variantStrings.addToCart;
        }
      });

      scope.querySelectorAll('script[data-selected-variant]').forEach((script) => {
        try {
          const variant = JSON.parse(script.textContent);
          variant.available = true;
          script.textContent = JSON.stringify(variant);
        } catch (error) {
          // Leave malformed third-party data untouched.
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => forceAvailable());
  document.addEventListener('product-info:loaded', (event) => forceAvailable(event.target));
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data?.html) forceAvailable(data.html);
      forceAvailable(document);
    });
  }
})();
